import { toast } from "sonner";
import { usePWAInstall } from "../lib/pwa";

/**
 * Inline `· install to desktop` link for the terminal edit page meta row.
 * Matches the other tv-link items. Renders its own leading separator so it can
 * disappear cleanly once the app is installed. Click → native install where
 * supported, else a short how-to toast.
 */
export default function PWAInstallLink() {
  const { installed, promptInstall } = usePWAInstall();
  if (installed) return null;

  const onClick = async () => {
    const ok = await promptInstall();
    if (!ok) {
      toast.message(
        "To install: use the install icon in your browser's address bar (Chrome / Edge), or on iPhone Safari tap Share → Add to Home Screen.",
      );
    }
  };

  return (
    <>
      <span className="text-[#bbb]">·</span>
      <button
        type="button"
        onClick={onClick}
        className="tv-link"
        data-testid="terminal-install-pwa"
        title="Install TerminalValue as a desktop / mobile app"
      >
        install to desktop
      </button>
    </>
  );
}
